// extracted by mini-css-extract-plugin
export default {"container":"dq-z","brandName":"eq-z","productName":"fq-z","productNamePdpEnhancements":"gq-z","breakLongProductName":"hq-z"};